import { render } from "./UserHistoryGameLevel.vue?vue&type=template&id=150cbd8e&scoped=true&ts=true"
import script from "./UserHistoryGameLevel.vue?vue&type=script&lang=ts"
export * from "./UserHistoryGameLevel.vue?vue&type=script&lang=ts"

import "./UserHistoryGameLevel.vue?vue&type=style&index=0&id=150cbd8e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150cbd8e"]])

export default __exports__